import { useRef, useEffect } from 'react';

const NoiseOverlay = ({ children, patternAlpha = 15, patternRefreshInterval = 2 }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return;

    let frame = 0;
    let animationId;

    const drawGrain = () => {
      if (canvas.width === 0 || canvas.height === 0) return;
      const imageData = ctx.createImageData(canvas.width, canvas.height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const value = Math.random() * 255;
        data[i] = value;
        data[i + 1] = value;
        data[i + 2] = value;
        data[i + 3] = patternAlpha;
      }

      ctx.putImageData(imageData, 0, 0);
    };

    const loop = () => {
      if (frame % patternRefreshInterval === 0) {
        drawGrain();
      }
      frame++;
      animationId = window.requestAnimationFrame(loop);
    };

    const start = () => {
      window.cancelAnimationFrame(animationId);
      frame = 0;
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      if (canvas.width > 0 && canvas.height > 0) {
        loop();
      }
    };

    const observer = new ResizeObserver(() => {
      start();
    });
    observer.observe(canvas);

    start();

    return () => {
      observer.disconnect();
      window.cancelAnimationFrame(animationId);
    };
  }, [patternAlpha, patternRefreshInterval]);

  return (
    <div className="relative overflow-hidden">
      {children}
      <canvas
        ref={canvasRef}
        className="pointer-events-none absolute top-0 left-0 w-full h-full"
        style={{
          imageRendering: 'pixelated'
        }}
      />
    </div>
  );
};

export default NoiseOverlay;
